<template>
    <b-container class="pb-0">
        <faq-card v-for="(item, index) in faqList" :key="index" :item="item" :index="index" />
    </b-container>
</template>

<script>
// @ is an alias to /src
import FaqCard from '@/components/FaqCard.vue'

export default {
  name: 'faq',
  components: {
    FaqCard
  },
  data () {
    return {
        faqList: [
            {
                title:"This is the question that can sometimes be quite long and take up a lot of space - but not multi-line, so that part is good?",
                description: "This is the answer and it can be be multi-line and could be quite long on the first line with auto-wrapping as content normally does, so this text tests the first line automatically wrapping and the next several lines test the multi-line.\n\n-------------------------------------------------\nThis is the answer Can be multi-line.\n\nThis is the answer Can be multi-line.\nThis is the answer Can be multi-line.\nThis is the answer Can be multi-line.\nThis is the answer Can be multi-line.",
                moreInformation: "http://sandbox.ioihan.com:3001/doc/ingredients-stlukes.pdf",
                tip: "See Ingredient File"
            },
            {
                title:"2 line answer with cr/lf included",
                description: "This is the answer\nCan be multi-line.",
            },
            {
                title:"Single short answer, no line breaks with link!",
                description: "This is the answer Can be multi-line, but does not have to be multi-line.",
                moreInformation: "http://sandbox.ioihan.com:3001/doc/ingredients-stlukes.pdf"
            },
            {
                title:"Question 4 is a little longer but not that long?",
                description: "This is the answer Can be multi-line, but does not have to be multi-line.  It can, however, be very long and wrap witout the CR/LF which means that the CSS is wrapping it all on its own witout the extra content forcing line breaks.",
                moreInformation: "http://sandbox.ioihan.com:3001/doc/ingredients-stlukes.pdf",
                tip: "Get some more information about this special link I have included"
            }

        ]
    }
  },
}
</script>

